import { configureStore } from '@reduxjs/toolkit';

import userSlice from './slices/user';
import UISlice from './slices/UI';
import payrollSlice from './slices/payroll';
import documentsSlice from './slices/documents';
import invoicesSlices from './slices/Invoices';
import fillOutInvoicesSlices from './slices/fillOutInvoices';
import agreementSlice from './slices/agreements';
import chargesSlice from './slices/charges';

export default configureStore({
  reducer: {
    userData: userSlice,
    UI: UISlice,
    payroll: payrollSlice,
    documents: documentsSlice,
    invoicesPay: invoicesSlices,
    fillOutInvoices: fillOutInvoicesSlices,
    agreement: agreementSlice,
    charges: chargesSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Optimización: Aumentar el umbral de warning para SerializableStateInvariantMiddleware
      // Esto reduce los warnings de performance en desarrollo sin afectar la funcionalidad
      serializableCheck: {
        // Aumentar el umbral de 32ms a 100ms para reducir warnings
        warnAfter: 100,
        // Ignorar ciertos paths que pueden contener objetos no serializables
        ignoredActions: [
          // Ignorar acciones que pueden contener funciones o objetos complejos
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/REGISTER',
          'persist/FLUSH',
          'persist/PAUSE',
          'persist/PURGE'
        ],
        // Ignorar ciertos paths del estado que pueden contener objetos no serializables
        ignoredActionsPaths: ['meta.arg', 'payload.timestamp'],
        ignoredPaths: [
          // Ignorar paths que pueden contener objetos complejos como fechas, funciones, etc.
          'UI.belvoParameters.integrationStartDate',
          'userData.businesses',
          'invoicesPay',
          'fillOutInvoices',
          'agreement',
          'charges'
        ]
      },
      // Optimización: Reducir la frecuencia de verificación de estado inmutable
      immutableCheck: {
        warnAfter: 100
      }
    })
});
